import { REGISTRAREMPRESA } from "../Constants/Endpoinst";
import { ApiRequestInterceptor } from "./apiRequest";

export const fetchGetEmpresasRegistros = async () => {
  const method = "GET";
  const response = await ApiRequestInterceptor(REGISTRAREMPRESA.getRegistros, method);

  // Retorna { code, data } para que createAsyncFetcher lo pueda desestructurar
  return { code: response.code, data: response.data };
};